import { TabConfig } from '@common/components/Tab/tabs.types'
import { ReadTaskPermission } from '@auth/permissionsEnum'
import ReaderTaskListTableTaskPool from './components/taskpool_tab/ReaderTaskListTableTaskPool'
import ReaderTaskListTableMyTasks from '@reader_task_list_view/pages/ReaderTaskListTableMyTasks'
import ReaderTaskListTableSkippedTasks from '@reader_task_list_view/pages/ReaderTaskListTableSkippedTasks'
import ReaderTaskListTableCompletedTasks from '@reader_task_list_view/pages/ReaderTaskListTableCompletedTasks'

export enum ReaderTaskListTabsKeyEnum {
  MY_TASKS = 'MY_TASKS',
  TASK_POOL = 'TASK_POOL',
  SKIPPED = 'SKIPPED',
  COMPLETE = 'COMPLETE',
}

export type ReaderTaskListTabsKey = ReaderTaskListTabsKeyEnum

export const createReaderTasksTabs = (subjectId?: string): Record<ReaderTaskListTabsKey, TabConfig> => ({
  MY_TASKS: {
    label: 'My tasks',
    content: <ReaderTaskListTableMyTasks subjectId={subjectId} />,
    permission: ReadTaskPermission.VIEW_ASSIGNED_TASKS,
  },
  TASK_POOL: {
    label: 'Task pool',
    content: <ReaderTaskListTableTaskPool subjectId={subjectId} />,
    permission: ReadTaskPermission.VIEW_TASK_POOL,
  },
  SKIPPED: {
    label: 'Skipped',
    content: <ReaderTaskListTableSkippedTasks subjectId={subjectId} />,
    permission: ReadTaskPermission.VIEW_SKIPPED_TASKS,
  },
  COMPLETE: {
    label: 'Complete',
    content: <ReaderTaskListTableCompletedTasks subjectId={subjectId} />,
    permission: ReadTaskPermission.VIEW_COMPLETED_TASKS,
  },
})
